/**
 * Labstep
 *
 * @desc ShowEdit component for CAS
 */

import { fieldCAS } from 'labstep-web/components/PubChemMetadata/Form/fields';
import { PubChemMetadataFormShowEditGeneric } from 'labstep-web/components/PubChemMetadata/Form/ShowEdit/Generic';
import type React from 'react';
import type { IPubChemMetadataFormShowEditCASProps } from './types';

export const PubChemMetadataFormShowEditCAS: React.FC<
  IPubChemMetadataFormShowEditCASProps
> = ({ parent, pubChemMetadata }) => (
  <PubChemMetadataFormShowEditGeneric
    pubChemMetadata={pubChemMetadata}
    parent={parent}
    field={fieldCAS}
  />
);
